import { Box } from "@mui/material";
import React from "react";
import ArrowRightIcon from "../../../shared/assets/icons/ArrowIcon";
import colors from "../../../shared/themes/colors";
import { ManufacturerReference, Rfq } from "../models/models";
import { dt } from "../../../shared/themes/redesignTokens";

interface OffersCountProps {
  count: number;
  text: string;
  item?: Rfq;
  openOffers?: () => void;
  openMatches?: () => void;
}

const OffersMathesCount = ({ count, text, openOffers, openMatches, item }: OffersCountProps) => {
  const countBox = {
    width: "fit-content",
    background: colors.primary.lightBlue4,
    borderRadius: "4px",
    color: colors.primary.white2
  };

  return (
    <>
      {count && count > 0 ? (
        <Box className="flex items-center" onClick={item ? openMatches : openOffers}>
          <Box
            className="text-12-medium px-1 flex items-center"
            style={countBox}
          >
            {count > 10 ? "10+" : count}
          </Box>
          {"\u00A0"}
          <Box className="text-12-medium" color="#333333">
            {text}
          </Box>
          <Box className="ml-2">
            <ArrowRightIcon color={dt.blue} />
          </Box>
        </Box>
      ) : (
        <Box className="text-12-medium">No {text}</Box>
      )}
    </>
  );
};
export default OffersMathesCount;
